﻿import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import { Row, Col } from "react-bootstrap";

import classes from "./login.module.scss";
import { ReactComponent as LogoSvg } from "@/assets/images/mobile/logo-agro.svg";

import Fetching from "@/components/Fetching/Fetching";

import { authLogin } from "@/redux/actions/auth.actions";
import { FINAL_LOGIN_REQUEST } from "@/redux/types/auth.types";

const Login = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const dispatch = useDispatch();
	const { addToast } = useToasts();

	const token = localStorage.getItem("token");

	const { message } = useParams();

	const [username, setUsername] = useState("");
	const [password, setPassword] = useState("");
	const [isFetching, setIsFetching] = useState(false);

	useEffect(() => {
		if (message && message !== "") {
			addToast(message, {
				appearance: "error",
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [message]);

	useEffect(() => {
		if (token) {
			navigate("/");
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [token]);

	const handleClickImage = () => {
		dispatch({ type: FINAL_LOGIN_REQUEST });
		navigate("/");
	};

	const handleLogin = async () => {
		if (username && password) {
			setIsFetching(true);
			await dispatch(authLogin(username, password))
				.then((_data) => {
					if (location.state) {
						if (location.state.from) {
							navigate(`/${location.state.from.pathname}`);
							return;
						}
					}

					navigate("/");

					setIsFetching(false);
				})
				.catch((_error) => {
					addToast("Usuario o contraseña incorrectos", {
						appearance: "error",
					});

					setIsFetching(false);
				});
		} else {
			addToast("Debe ingresar usuario y contraseña", {
				appearance: "error",
			});
		}
	};

	const handleKeyPress = (e) => {
		const keyCode = e.which || e.keyCode;
		if (keyCode === 13) {
			handleLogin();
		}
	};

	if (isFetching) {
		return <Fetching />;
	}

	return (
		<div className={classes.loginGlobal}>
			<Row className={classes.main}>
				<Col sm={12} className={classes.header}>
					<LogoSvg className="logo" onClick={() => handleClickImage()} />
				</Col>

				<Col sm={12} className={classes.form}>
					<Row>
						<Col sm={12} className={classes.title}>
							INICIAR SESIÓN
						</Col>

						<Col className={classes.inputContent} sm={12}>
							<input
								className={classes.input}
								type="text"
								placeholder="Usuario"
								value={username}
								onChange={(e) => setUsername(e.currentTarget.value)}
								onKeyPress={(e) => handleKeyPress(e)}
							/>
						</Col>

						<Col className={classes.inputContent} sm={12}>
							<input
								type="password"
								className={classes.input}
								placeholder="Contraseña"
								value={password}
								onChange={(e) => setPassword(e.currentTarget.value)}
								onKeyPress={(e) => handleKeyPress(e)}
							/>
						</Col>
					</Row>
				</Col>

				<Col sm={12} className={classes.submit} onClick={() => handleLogin()}>
					Continuar
				</Col>

				<Col sm={12} className={classes.forgotPassword} onClick={() => navigate("/recuperar_contrasena")}>
					Restablecer contraseña
				</Col>
			</Row>
		</div>
	);
};

export default Login;
